module.exports = __webpack_public_path__ + "static/jessie.4b98f372.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/jessie.svg
// module id = 381
// module chunks = 73016943110679